import * as api from '../../../apis/sponsor'
import { createSelector } from 'reselect'

const FETCH_SPONSOR_STATISTICS_REQUESTED = 'FETCH_SPONSOR_STATISTICS_REQUESTED'
const FETCH_SPONSOR_STATISTICS_SUCCESS = 'FETCH_SPONSOR_STATISTICS_SUCCESS'
const FETCH_SPONSOR_STATISTICS_FAILED = 'FETCH_SPONSOR_STATISTICS_FAILED'

export const fetchSponsorStatistics = (token) => (dispatch) => {
	dispatch({ type: FETCH_SPONSOR_STATISTICS_REQUESTED, data: {} })
	api.fetchStatistics(token).then((response) => {
		if (response && response.isSuccessful) {
			return dispatch({ type: FETCH_SPONSOR_STATISTICS_SUCCESS, data: response })
		} else {
			return dispatch({ type: FETCH_SPONSOR_STATISTICS_FAILED, data: {} })
		}
	})
	return
}

const initial = {
	statistics: null
}

export const reducer = (state = initial, action) => {
	switch (action.type) {
		case FETCH_SPONSOR_STATISTICS_SUCCESS:
			return { ...state, statistics: action.data }
		default:
			return { ...state }
	}
}

const mainSelector = (state) => state.sponsor

export const sponsorStatisticsSelector = createSelector(mainSelector, (state) => {
	return state && state.statistics
})
